/*
 * @Author: your name
 * @Date: 2022-11-10 11:09:04
 * @LastEditTime: 2022-12-13 18:52:25
 * @LastEditors: luting
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/InductiveManage/index.tsx
 */
import React, { useState } from 'react';
import styles from './index.less';

import SelectEnv from './SelectEnv';
import EnvSet from './EnvSet';

// const nanotubeProgress = ['select', 'form'];
const InductiveManage = () => {
  const [current, setCurrent] = useState('select');

  const changeCurrent = (progress: string) => {
    setCurrent(progress);
  };

  return <div className={styles.container}>
    {
      current === 'select' ? <SelectEnv changeCurrent={changeCurrent} /> : <EnvSet changeCurrent={changeCurrent} />
    }
  </div>;
};

export default InductiveManage;